module.exports = __webpack_public_path__ + "img/video.e48455d2.svg";